import React, { useEffect, useState } from 'react';
import './ProfilePage.css';
import { db } from './firebase';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom';
import { getTotalPosicoes, categoriasPorModo } from "./services/estruturaCategorias";
import nomesBonitosCategoria from "./utils/nomesBonitosCategoria";
import AlertaUrgente from "./components/AlertaUrgente";
import SeloPopupPublico from "./components/SeloPopupPublico";
import PopupCompartilhar from "./components/PopupCompartilhar";

function ProfilePublicPage() {
  const [config, setConfig] = useState({});
  const { uid } = useParams();
  const [usuarioFirestore, setUsuarioFirestore] = useState(null);
  const [previsoesAtivas, setPrevisoesAtivas] = useState({});
  const [modosComApostas, setModosComApostas] = useState([]); // <-- array, não objeto
  const [popupSelosAberto, setPopupSelosAberto] = useState(false);
  const [dadosSelos, setDadosSelos] = useState({});
  const [modoSelecionado, setModoSelecionado] = useState("");
  const [todasPrevisoes, setTodasPrevisoes] = useState({}); // está correto
  const [ranking, setRanking] = useState({});
  const [carregandoPerfil, setCarregandoPerfil] = useState(true);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);
  const [totalPontos, setTotalPontos] = useState(0);
  const navigate = useNavigate();
  const imagemPerfilDefault = "https://firebasestorage.googleapis.com/v0/b/previsoesoscar.firebasestorage.app/o/fotosUsuarios%2Fdefaults%2Fperfil.png?alt=media&token=e1de994b-b337-41ea-992f-fb0929611d36";
  const imagemCabecalhoDefault = "https://firebasestorage.googleapis.com/v0/b/previsoesoscar.firebasestorage.app/o/fotosUsuarios%2Fdefaults%2Fcapa.png?alt=media&token=5a95f438-714b-4eea-a506-bdb619c43c5a";
  const [popupCompartilharAberto, setPopupCompartilharAberto] = useState(false);
  
  const linkPerfilPublico = `https://www.termometrooscar.com/termometeiro.html#/perfil-publico/${uid}`;
  
  useEffect(() => {
    async function carregarSelos() {
      try {
        const snapshot = await getDocs(collection(db, "selos"));
        const resultado = {};
        snapshot.forEach((doc) => {
          resultado[doc.id] = doc.data(); // cada doc.id é o seloId
        });
        setDadosSelos(resultado);
      } catch (erro) {
        console.error("Erro ao carregar selos:", erro);
      }
    }

    carregarSelos();
  }, []);


    function abrirPopupSelos() {
    setPopupSelosAberto(true);
  }

  function fecharPopupSelos() {
    setPopupSelosAberto(false);
  }

  // 🔎 Calcula a data mais recente ENTRE TODAS as categorias de TODOS os modos
useEffect(() => {
  const dados = todasPrevisoes;
  if (!dados || typeof dados !== "object") {
    setUltimaAtualizacao(null);
    return;
  }

  let maisRecente = null;

  // só considera chaves no formato "algo-indicados" ou "algo-vencedores"
  for (const modo of Object.keys(dados)) {
    if (!/^[a-z]+-(indicados|vencedores)$/.test(modo)) continue;
    const blocoModo = dados[modo];
    if (!blocoModo || typeof blocoModo !== "object") continue;

    for (const categoriaId of Object.keys(blocoModo)) {
      const categoria = blocoModo[categoriaId];
      if (!categoria || typeof categoria !== "object") continue;

      const data = categoria.dataAtualizacao;
      if (!data) continue;

      const dataObj =
        data instanceof Date
          ? data
          : data?.seconds
          ? new Date(data.seconds * 1000)
          : typeof data === "string"
          ? new Date(data)
          : null;

      if (dataObj && !isNaN(dataObj)) {
        if (!maisRecente || dataObj > maisRecente) {
          maisRecente = dataObj;
        }
      }
    }
  }

  setUltimaAtualizacao(maisRecente || null);
}, [todasPrevisoes]);


  const premiacoes = [
    { nome: 'Oscar', id: 'oscar' },
    { nome: 'Globo de Ouro', id: 'globodeouro' },
    { nome: 'Critics Choice', id: 'criticschoice' },
    { nome: 'The Actor Awards', id: 'sagawards' },
    { nome: 'BAFTA', id: 'bafta' },
    { nome: 'DGA', id: 'dga' },
    { nome: 'PGA', id: 'pga' },
  ];

function formatarDataHoraExtenso(valor) {
  if (!valor) return "—";

  let data;

  if (valor instanceof Date) {
    // Já é um Date válido
    data = valor;
  } else if (typeof valor === "string") {
    // String ISO
    data = new Date(valor);
  } else if (valor?.seconds) {
    // Timestamp Firestore
    data = new Date(valor.seconds * 1000);
  } else {
    return "—";
  }

  if (isNaN(data.getTime())) return "—";

  const dia = data.getDate();
  const mes = data.toLocaleDateString("pt-PT", { month: "long" });
  const ano = data.getFullYear();
  const horas = data.getHours().toString().padStart(2, "0");
  const minutos = data.getMinutes().toString().padStart(2, "0");

  return `${dia} de ${mes} de ${ano} às ${horas}h${minutos}`;
}

  function trocarModo(novoModo) {
  setModoSelecionado(novoModo);
}

useEffect(() => {
  if (modoSelecionado && todasPrevisoes[modoSelecionado]) {
    setPrevisoesAtivas(todasPrevisoes[modoSelecionado]);
  } else {
    setPrevisoesAtivas({});
  }
}, [modoSelecionado, todasPrevisoes]);

  function gerarNomeModo(modo) {
    const [premiacao, tipo] = modo.split("-");
    const mapaNomes = {
      oscar: "Oscar",
      globodeouro: "Globo de Ouro",
      bafta: "BAFTA",
      sagawards: "The Actor Awards",
      criticschoice: "Critics Choice",
      dga: "DGA",
      pga: "PGA",
    };

    const tipoTexto = tipo === "indicados" ? "Aposta dos Indicados ao" : "Aposta dos Vencedores ao";
    return `${tipoTexto} ${mapaNomes[premiacao] || premiacao}`;
  }

useEffect(() => {
  console.log("✅ UID recebido da URL:", uid);
  if (typeof uid !== "string" || uid.trim() === "") {
    // Sem UID válido → não deixa o loader preso
    setCarregandoPerfil(false);
    return;
  }

  async function carregarDadosDoSnapPublico() {
    setCarregandoPerfil(true);
    const chaveCache = `perfil-publico-${uid}`;

    try {
      // 1️⃣ Tenta cache (early-return seguro; finally desliga loader)
      const cacheBruto = sessionStorage.getItem(chaveCache);
      if (cacheBruto) {
        try {
          const cache = JSON.parse(cacheBruto);

          setModosComApostas(cache.modosComApostas || []);
          setTodasPrevisoes(cache.todasPrevisoes || {});
          setUsuarioFirestore(cache.usuarioFirestore || null);

          const modoRestaurado = cache.modoSelecionado || "";
          setModoSelecionado(modoRestaurado);
          setPrevisoesAtivas((cache.todasPrevisoes || {})[modoRestaurado] || {});

          // Ranking (com pontos/porcentagem)
          const rankingCompleto = {};
          for (const modo of cache.modosComApostas || []) {
            const blocoModo = (cache.todasPrevisoes || {})[modo] || {};
            rankingCompleto[modo] = {
              ...blocoModo,
              pontos: modo === modoRestaurado ? (cache.totalPontos ?? null) : null,
              porcentagem: blocoModo.porcentagem ?? null,
            };
          }
          setRanking(rankingCompleto);
          setTotalPontos(rankingCompleto[modoRestaurado]?.pontos ?? 0);

          // Data mais recente global (todas as categorias de todos os modos)
          const dados = cache.todasPrevisoes || {};
          let maisRecente = null;
          for (const m of Object.keys(dados)) {
            const bloco = dados[m];
            if (!bloco || typeof bloco !== "object") continue;
            for (const catId of Object.keys(bloco)) {
              const cat = bloco[catId];
              if (!cat || typeof cat !== "object") continue;
              const data = cat.dataAtualizacao;
              const d = data?.seconds
                ? new Date(data.seconds * 1000)
                : (typeof data === "string" ? new Date(data) : (data instanceof Date ? data : null));
              if (d && !isNaN(d)) {
                if (!maisRecente || d > maisRecente) maisRecente = d;
              }
            }
          }
          setUltimaAtualizacao(maisRecente || null);

          console.log("🧠 Cache público restaurado com sucesso.");
          return; // finally desliga o loader
        } catch (e) {
          console.warn("⚠️ Erro ao ler cache. Ignorando…");
        }
      }

      // 2️⃣ Snapshot público
      const ref = doc(db, "usuarios", uid, "snapDropdown2026", "dados");
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        console.warn("❌ SnapDropdown público não encontrado (usuário ainda sem apostas)");
        // Estado “vazio” para abrir a página sem travar
        setModosComApostas([]);
        setTodasPrevisoes({});
        setRanking({});
        setModoSelecionado("");
        setPrevisoesAtivas({});
        setTotalPontos(0);
        setUltimaAtualizacao(null);

        // Ainda tentamos puxar dados básicos do usuário (nome/fotos) para o topo
        try {
          const usuarioRef = doc(db, "usuarios", uid);
          const snapUsuario = await getDoc(usuarioRef);
          setUsuarioFirestore(snapUsuario.exists() ? snapUsuario.data() : null);
        } catch (e) {
          console.warn("⚠️ Falha ao carregar dados do usuário público:", e);
          setUsuarioFirestore(null);
        }
        return; // finally desliga o loader
      }

      const dados = snap.data() || {};
      console.log("📦 Dados brutos do snapshot público:", dados);

      // Buscar dados públicos do usuário (nome, capa, perfil, etc.)
      let dadosUsuario = null;
      try {
        const usuarioRef = doc(db, "usuarios", uid);
        const snapUsuario = await getDoc(usuarioRef);
        if (snapUsuario.exists()) {
          dadosUsuario = snapUsuario.data();
          setUsuarioFirestore(dadosUsuario);
        } else {
          console.warn("❌ Usuário público não encontrado.");
          setUsuarioFirestore(null);
        }
      } catch (e) {
        console.warn("⚠️ Falha ao ler usuário público:", e);
        setUsuarioFirestore(null);
      }

      // Data mais recente por modo (campo 'ultimaAtualizacao' em cada modo)
      let maisRecente = null;
      for (const m of Object.keys(dados)) {
        const bloco = dados[m];
        if (!bloco || typeof bloco !== "object") continue;
        const data = bloco.ultimaAtualizacao;
        const d = data?.seconds
          ? new Date(data.seconds * 1000)
          : (typeof data === "string" ? new Date(data) : (data instanceof Date ? data : null));
        if (d && !isNaN(d)) {
          if (!maisRecente || d > maisRecente) maisRecente = d;
        }
      }
      setUltimaAtualizacao(maisRecente || null);

      if (typeof dados.totalPontos === "number") {
        setTotalPontos(dados.totalPontos);
      }

      // Modos válidos
      const modosComDados = Object.keys(dados).filter((m) =>
        /^[a-z]+-(indicados|vencedores)$/.test(m)
      );

      if (modosComDados.length === 0) {
        console.warn("⚠️ Nenhum modo válido encontrado no snapshot público.");
        // Abre “vazio” mesmo assim
        setModosComApostas([]);
        setTodasPrevisoes({});
        setRanking({});
        setModoSelecionado("");
        setPrevisoesAtivas({});
        setTotalPontos(0);
        return; // finally desliga o loader
      }

      const prioridade = [
        "oscar-vencedores", "oscar-indicados",
        "globodeouro-vencedores", "globodeouro-indicados",
        "bafta-vencedores", "bafta-indicados",
        "sagawards-vencedores", "sagawards-indicados",
        "criticschoice-vencedores", "criticschoice-indicados",
        "dga-vencedores", "dga-indicados",
        "pga-vencedores", "pga-indicados",
      ];
      modosComDados.sort((a, b) => prioridade.indexOf(a) - prioridade.indexOf(b));
      const melhorModo = modosComDados[0];

      setModosComApostas(modosComDados);
      setTodasPrevisoes(dados);
      setModoSelecionado(melhorModo);
      setPrevisoesAtivas(dados[melhorModo] || {});
      setRanking(dados);

      // Cache público
      sessionStorage.setItem(
        chaveCache,
        JSON.stringify({
          modosComApostas: modosComDados,
          modoSelecionado: melhorModo,
          todasPrevisoes: dados,
          totalPontos: dados.totalPontos ?? null,
          usuarioFirestore: dadosUsuario,
        })
      );
      console.log("✅ SnapDropdown público carregado e cache salvo");
    } catch (erro) {
      console.error("❌ Erro ao carregar snapDropdown público:", erro);
      // Fallback “vazio” para não travar
      setModosComApostas([]);
      setTodasPrevisoes({});
      setRanking({});
      setModoSelecionado("");
      setPrevisoesAtivas({});
      setTotalPontos(0);
      setUltimaAtualizacao(null);
      setUsuarioFirestore(null);
    } finally {
      setCarregandoPerfil(false); // 🔴 nunca mais fica preso
    }
  }

  carregarDadosDoSnapPublico();
}, [uid]);

  return (
  <div className="profile-container-wrapper">
    <AlertaUrgente />
  {carregandoPerfil && (
    <div className="overlay-carregando">
      <div className="conteudo-carregando">
        <img
          src="https://i.imgur.com/t0gsZRT.png"
          alt="A carregar"
          className="icone-carregando"
        />
        <p className="texto-carregando">Carregando dados do perfil...</p>
      </div>
    </div>
  )}
    <div className={`profile-container ${carregandoPerfil ? 'blurred' : ''}`}>
      {/* TOPO */}
     <div className="header">
       {/* FOTO DE PERFIL SOBREPOSTA */}
      <div className={`foto-usuario ${usuarioFirestore?.especialista ? "especialista" : ""}`}>
      <img
        className="foto-perfil"
        src={usuarioFirestore?.fotoPerfil || imagemPerfilDefault}
        alt="Foto de perfil"
      />
    </div>
      {/* IMAGEM DE FUNDO */}
      <div className="foto-cabecalho">
        <img
          className="imagem-capa"
          src={usuarioFirestore?.fotoCabecalho || imagemCabecalhoDefault}
          alt="Foto de cabeçalho"
        />
      </div>

      {/* BOTÕES SOBREPOSTOS */}
      <div className="header-buttons">
        <button className="btn blue" onClick={() => setPopupCompartilharAberto(true)}>COMPARTILHAR</button>

        {popupCompartilharAberto && (
        <PopupCompartilhar
            link={linkPerfilPublico}
            onClose={() => setPopupCompartilharAberto(false)}
        />
        )}
      </div>
    </div>

      <div className="usuario-info">
         <h1>
          {usuarioFirestore?.nome && usuarioFirestore?.sobrenome
            ? `${usuarioFirestore.nome} ${usuarioFirestore.sobrenome}`
            : "Usuário"}
        </h1>
        <p className="estado">Estado: <strong>{usuarioFirestore?.estado || "--"}</strong></p>

        {usuarioFirestore?.especialista && (
          <div className="tag-especialista">ESPECIALISTA DO OSCAR</div>
        )}
        {usuarioFirestore?.denominacao && usuarioFirestore?.linkParaSeguir ? (
          <a
            href={usuarioFirestore.linkParaSeguir}
            target="_blank"
            rel="noopener noreferrer"
            className="denominacao link-denominacao"
          >
            {usuarioFirestore.denominacao}
          </a>
        ) : (
          <div className="denominacao">
            {usuarioFirestore?.denominacao || ""}
          </div>
        )}

        <div className="pontuacao-container">
          <div className="pontuacao-label">PONTUAÇÃO</div>
          <div className="pontuacao-numero">{totalPontos}</div>
        </div>

         <p className="pontuacao-info">Atualizações no perfil<br />podem levar até algumas horas.</p>
        <hr className="dotted" />
        <div className="selos-section">
          {usuarioFirestore?.selooficial && dadosSelos[usuarioFirestore.selooficial] && (
              <div className="selo-oficial-bloco">
                <div className="tooltip-wrapper">
                  <img
                    className="selo-oficial-img"
                    src={dadosSelos[usuarioFirestore.selooficial].imagemUrl}
                    alt={dadosSelos[usuarioFirestore.selooficial].nome}
                  />
                  <div className="tooltip-cima">
                    {dadosSelos[usuarioFirestore.selooficial].motivo}
                  </div>
                </div>
              </div>
            )}
          <button className="selos-btn" onClick={abrirPopupSelos}>PINS GANHOS</button>
        </div>

        {popupSelosAberto && (
        <SeloPopupPublico
            selos={usuarioFirestore?.selosGanhos || []}
            dadosSelos={dadosSelos}
            onClose={fecharPopupSelos}
        />
        )}

        <hr className="dotted" />

       <p className="ultima-atualizacao">
        ÚLTIMA ATUALIZAÇÃO DE APOSTAS<br />
        <strong className="ultima-atualizacao-numero">
          {formatarDataHoraExtenso(ultimaAtualizacao)}
        </strong>
      </p>
      </div>

      <div className="Containerspace">
      
      {/* BLOCO EXCLUSIVO PARA ESPECIALISTAS */}
      {usuarioFirestore?.especialista && (
      <div className="bloco-especialista">
        {usuarioFirestore?.sobreMim && (
           <p className="texto-sobre"><div className="titulo-sobre-mim">Sobre Mim</div> {usuarioFirestore.sobreMim}</p>
        )}
      </div>
    )}

      {/* MINHAS PREVISÕES */}
      <div className="previsoes-bloco">
        <div className="previsoes-titulo">MINHAS PREVISÕES 2026</div>
        <div className="previsoes-dropdown">
        <select
          value={modoSelecionado}
          onChange={(e) => trocarModo(e.target.value)}
          className="dropdown-modos"
        >
          {modosComApostas
  .filter((modo) => /^[a-z]+-(indicados|vencedores)$/.test(modo)) // apenas modos válidos
  .map((modo) => (
    <option key={modo} value={modo}>
      {gerarNomeModo(modo)}
    </option>
))}
        </select>
      </div>

       {ranking?.[modoSelecionado]?.porcentagem && (
  <div className="barra-porcentagem">
    Porcentagem de acertos: {ranking[modoSelecionado].porcentagem}%
    
    {ranking[modoSelecionado]?.pontosmodo !== undefined && (
      <div className="pontosmodobarra">
        Total de Pontos: {ranking[modoSelecionado].pontosmodo}
      </div>
    )}
  </div>
)}

       <div className="blocos-previsoes">
  {(() => {
    // Se categoriasPorModo[premiacao] não existir, usa as categorias com apostas
    const premiacao = modoSelecionado.split("-")[0];

    const todasCategorias = Object.keys(previsoesAtivas || {});
    const categoriasDefinidas = categoriasPorModo[modoSelecionado] || todasCategorias;
    const listaOrdenada = categoriasDefinidas.filter(cat => todasCategorias.includes(cat));

    console.log("🧩 Entrou no render dos blocos");
console.log("🎯 Categorias encontradas:", Object.keys(previsoesAtivas || {}));

    return listaOrdenada.map((categoriaId) => {
      const categoria = previsoesAtivas?.[categoriaId];
      const posicoes = Object.entries(categoria || {})
      .filter(([key]) => key !== "dataAtualizacao" && !isNaN(Number(key)))
      .map(([_, val]) => val)
      .filter((item) => item?.titulo)
      .sort((a, b) => a.ordem - b.ordem);
      const dataMaisRecente = categoria?.dataAtualizacao || null;

      return (
        <div className="bloco-previsao" key={categoriaId}>
          <div className="cabecalho-previsao amarelo">
          {nomesBonitosCategoria[categoriaId] || categoriaId}
          {ranking?.[modoSelecionado]?.[categoriaId]?.pontos !== undefined && (
            <span className="pontos-categoria"> {ranking[modoSelecionado][categoriaId].pontos} pontos</span>
          )}
        </div>

          <div className="lista-posicoes">
            {posicoes
              .filter((pos) => pos?.titulo)
              .sort((a, b) => a.ordem - b.ordem)
              .map((pos, i) => {
                const isAcertouTrue  = pos.acertou === true || pos.acertou === "true";
                const isAcertouFalse = pos.acertou === false || pos.acertou === "false";

                return (
                  <div
                    className={`item-posicao ${isAcertouFalse ? "opaco" : ""}`}
                    key={i}
                    aria-disabled={isAcertouFalse ? "true" : "false"}
                  >
                    <div className={`posicao-circulo cor-${i + 1}`}>{i + 1}º</div>
                    <div className="ligacao-horizontal" />
                    <div className="wrapper-circular">
                      <img
                        className="poster-candidato"
                        src={pos.imagem || "https://i.imgur.com/6MbQoCt.png"}
                        alt={pos.titulo}
                      />
                    </div>
                    <div className="info-candidato">
                      <strong>{pos.titulo}</strong>
                      <div className="subinfo">
                        {pos.filme || pos.pais || ""}
                        {isAcertouTrue && <span className="selo-acertou">ACERTEI</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="data-atualizacao">
            Última Atualização: <strong>{dataMaisRecente ? formatarDataHoraExtenso(dataMaisRecente) : "—"}</strong>
          </div>
        </div>
      );
    });
  })()}
</div>
        </div>
        <div className="arquivo">Arquivo</div>


      </div>
    </div>
      </div>
  );
}

export default ProfilePublicPage;